import { useRouter } from "next/router";
import { useCallback } from "react";
import { getCookie } from "@repo/client-cookies";

type Section = "topshop" | "topman";

export const useNavigation = () => {
  const router = useRouter();
  const floor = getCookie("floor");

  const navigateToSection = useCallback(
    (target: Section, delay = 500) => {
      const store = router.query.path as string;

      if (typeof window !== "undefined" && !floor) {
        window.sessionStorage.setItem("first", "1");
      }

      const timeout = setTimeout(() => {
        router.push(`/${store[0]}/${target}`, undefined, { shallow: false });
      }, delay);

      return () => clearTimeout(timeout);
    },
    [router, floor],
  );
  return { navigateToSection };
};
